import {
  prewarmGateCoordinatesOnPointerDown,
  prewarmCoordinatesForGate,
  useCoordinatesGate,
  useGateSubformCoordinatesPrewarm,
} from "@/src/modules/core/hooks/use-coordinates-gate";

export type UseComplianceGateCoordinatesOptions = {
  /** Delay, interrupt, stay-past-end, or other sub-form that submits with GPS. */
  subformOpen?: boolean;
};

/**
 * Shared GPS prep for blocking compliance gates (break notice/active, shift end).
 * - Warms coordinates while the gate is open
 * - Refreshes the mobile submit buffer before the 30s TTL
 * - Re-warms when a GPS sub-form opens
 */
export function useComplianceGateCoordinates(
  active: boolean,
  options: UseComplianceGateCoordinatesOptions = {},
) {
  const {subformOpen = false} = options;
  const {submitBlockedByLocation} = useCoordinatesGate(true, {
    active,
    keepSubmitBufferWarm: active,
  });
  useGateSubformCoordinatesPrewarm(active, subformOpen, submitBlockedByLocation);

  return {submitBlockedByLocation};
}

export {
  prewarmCoordinatesForGate,
  prewarmGateCoordinatesOnPointerDown,
};
